<template>
  <el-dialog 
    :visible.sync="dialogVisible" 
    append-to-body
    width="360px"
    :show-close="false"
    custom-class="login-form-dialog">
    <template>
      <div class="logo-wrap">
        <img src="@/assets/logo.png">
      </div>
      <div v-if="!loginType" class="login-type-wrap">
        <div class="login-type-tips">Which type of account do you want to sign in to?</div>
        <el-button type="primary" style="width: 100%; height: 50px;" @click="loginType = 5" class="login-btn">Student</el-button>
        <el-button type="primary" style="width: 100%; height: 50px;" @click="loginType = 3" class="login-btn">Counselor</el-button>
        <el-button type="primary" style="width: 100%; height: 50px;" @click="loginType = 9" class="login-btn">Teacher/Principal</el-button>
      </div>
      <el-form v-else ref="loginForm" :model="loginData">
        <el-form-item prop="email" label="Email">
          <el-input 
            v-model="loginData.account" 
            placeholder="Please input E-mail" 
            maxlength="200"
            @keyup.native.enter="doLogin"/>
        </el-form-item>
        <el-form-item prop="password" label="Password">
          <el-input
            ref="password"
            v-model="loginData.password"
            placeholder="Please input password"
            name="password"
            type="password"
            maxlength="20"
            @keyup.native.enter="doLogin"/>
        </el-form-item>
        <div class="btn-wrap">
          <el-button type="primary" style="width: 100%;" @click="doLogin" class="login-btn">Login Now</el-button>
          <el-link class="back-link" @click="loginType = 0">back</el-link>
          <el-link class="back-link" @click="onForgetPassword">Forget the password?</el-link>
        </div>
      </el-form>
      <password-find ref="passwordFind"/>
      <password-change-no-login ref="passwordChangeNoLogin"/>
    </template>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { setToken } from '@/utils/auth'
import PasswordFind from '_c/password-find'
import PasswordChangeNoLogin from '_c/password-change-no-login'

export default {
  components: { PasswordFind, PasswordChangeNoLogin },
  data() {
    return {
      dialogVisible: false,
      loginData: {
        account: '',
        password: '',
      },
      loginType: 0,
    }
  },
  methods: {
    ...mapActions({
      actionUserLogin: 'userLogin',
      actionUserInfo: 'userInfo',
    }),
    async show() {
      this.dialogVisible = true
    },
    onForgetPassword() {
      if (this.loginType == 3 || this.loginType == 9) {
        this.$message.warning('Please contact Contest Advisor to change your password.')
      } if (this.loginType == 5) {
        this.$refs.passwordFind.show()
      }
    },
    async doLogin() {
      try {
        this.loading = true
        const { account, password } = this.loginData;
        if (!account) {
          throw new Error('Pleace input account');
        }
        const ret = await this.actionUserLogin({
          account,
          password,
          type: this.loginType
        })
        this.loading = false
        if (ret.code === 0) {
          const { token, role } = ret.data
          setToken(token)
          this.actionUserInfo()
          this.dialogVisible = false
          if (role == 1) {
            this.$router.push('/ad')
          } else {
            window.location.reload()
          }
        }
        if (ret.code === -2) {
          // this.$message.warning(ret.msg)
          this.$refs.passwordChangeNoLogin.show({
            account,
            password
          })
        }
      } catch (e) {
        this.$message.warning(e.message);
      }
    },
  }
}
</script>
<style lang="less">
.login-form-dialog {
  border-radius: 12px;
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>
<style lang="less" scoped>
.logo-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    width: 64px;
  }
}
.login-type-wrap {
  padding: 32px 0 64px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: center;
}
.btn-wrap {
  margin-top: 30px;
  display: flex;
  align-items: center;
  flex-direction: column;
  .back-link {
    margin: 16px auto 0;
  }
}
  .login-btn {
    background: @themeColor1;
    border: none;
    border-radius: 40px;
    margin: 0;
    &:active {
      opacity: .8;
    }
    &:hover {
      opacity: .9;
    }
  }
</style>
